import { ActionIcon, Card, SimpleGrid, Text } from '@mantine/core'
import React, { useState } from 'react'

import { Icons } from 'src/common/components'

import {
  ESCALATION_PROGRAM_OPTIONS,
  EscalationProgramEnum,
} from '../../escalation.types'
import styles from './escalation-form-header.module.scss'

const EscalationCaseFormComponent = ({
  program,
}: {
  program: EscalationProgramEnum
}) => {
  const [expandHeader, setExpandHeader] = useState(false)

  const getHeaderColor = (program: EscalationProgramEnum) => {
    switch (program) {
      case EscalationProgramEnum.BCF:
        return 'orange'
      case EscalationProgramEnum.DRIVERS_BENEFIT:
        return 'green'
      case EscalationProgramEnum.DRIVERS_GUILD:
        return 'blue'
      default:
        return 'other'
    }
  }

  const getProgramInfo = (program: EscalationProgramEnum) => {
    const programOption = ESCALATION_PROGRAM_OPTIONS.find(
      (option) => option.value === program,
    )
    return programOption
  }

  return (
    <SimpleGrid>
      <Card variant="contained" radius={8} withBorder className={styles.card}>
        <Card.Section
          className={styles[`card-header-${getHeaderColor(program)}`]}
        >
          <Text fw={700}>{getProgramInfo(program)?.header || ''}</Text>
        </Card.Section>
        <Card.Section p={10} mr={40}>
          <ActionIcon
            className={
              expandHeader ? styles[`action-icon-open`] : styles['action-icon']
            }
            variant="transparent"
            onClick={() => setExpandHeader((prev) => !prev)}
          >
            <Icons.GreenCircledArrowSelect
              className={styles[`svg-${getHeaderColor(program)}`]}
            />
          </ActionIcon>
          <Text
            ta="justify"
            ml={10}
            className={
              expandHeader ? styles['card-body'] : styles['card-body-closed']
            }
            dangerouslySetInnerHTML={{
              __html:
                getProgramInfo(program as EscalationProgramEnum)?.headerText ||
                ``,
            }}
          />
        </Card.Section>
      </Card>
    </SimpleGrid>
  )
}
export default EscalationCaseFormComponent
